var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('UserTable',{attrs:{"users":_vm.users},on:{"remove-user":function($event){_vm.onRemoveUser($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }